/* eslint-disable no-shadow */
import { httpsCallable } from 'firebase/functions';
import { functions } from '.';

const createCheckoutLink = httpsCallable(functions, 'createCheckoutLink');

// Billing B2.1: the server shows these refusals to the booker as they are
// (functions/helper/checkout.js, MESSAGES). Other refusals get a general message.
// Billing B4.2, B4.4, B4.3 + B0.7a: their refusals too.
const SHOWN_REASONS = [
  'taken',
  'held',
  'sunday',
  'no-phone',
  'second-payment',
  'disabled',
  'too-many-guests',
  'over-capacity',
  'terms',
  'no-times',
  'end-before-start',
  'saturday-late'
];

// Billing B2.1 + B2.2: the server works out who books, the days, the price,
// live or test money and the return links. It takes only these fields.
// Billing B4.2: a new booking sends guestCount and alcohol; a second payment does not.
// B4.4: termsAccepted is the tick in the booking box (new bookings only).
// B4.3: a second payment sends no times: the server reads them from the booking.
export const makeCheckoutLink = async ({ venue, start, end, startTime, endTime, typePayment, booking_id = null, guestCount, alcohol, termsAccepted = false }) => {
  try {
    const { data: url } = await createCheckoutLink({
      venue_id: venue.id,
      start,
      end,
      // null, not left out: a box with no times must be refused, not taken for an old page.
      ...(booking_id ? {} : { startTime: startTime || null, endTime: endTime || null }),
      typeBooking: typePayment,
      booking_id,
      ...(booking_id ? {} : { guestCount, alcohol }),
      termsAccepted: termsAccepted === true,
      returnPath: window.location.pathname + window.location.search
    });
    return { url };
  } catch (e) {
    const reason = e.details && e.details.reason;
    return {
      error: true,
      unauthenticated: e.message === 'The function must be called while authenticated.',
      message: SHOWN_REASONS.includes(reason) ? e.message : ''
    };
  }
};
